
import { defineComponent, PropType } from 'vue'

export default defineComponent({
  name: 'FormItem',
  props: {
    label: String as PropType<string>,
  },
})
